import { render } from "./SuggestionTags.vue?vue&type=template&id=266f6fac"
import script from "./SuggestionTags.vue?vue&type=script&lang=js"
export * from "./SuggestionTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__